import { Component, Inject, Input } from '@angular/core';
import { ApiService } from '@lsq-frontend/angular-shared/api-service';
import { ISettings, SETTINGS } from '@lsq-frontend/angular-shared/settings';
import { FileType } from '@lsq-frontend/remote-services/enterprise/common';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { cloneDeep } from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { Icons } from '../../../constants/icons.constants';
import { DownloadService } from '../../../services/api/download.service';
@Component({
    selector: 'lsq-export-button',
    template: `
        <lsq-button
            (buttonClick)="handleClick()"
            [submitting]="isLoadingReport"
            [appearance]="isTransparent ? 'transparent' : 'secondary'"
            [buttonClass]="isIcon ? '' : 'icon-export'"
            [disabled]="disabled"
        >
            <ng-container *ngIf="!isIcon">Export Data</ng-container>
            <lsq-icon
                *ngIf="isIcon"
                [type]="icons.Export"
                [color]="disabled ? 'graphic-gray' : 'black'"
            ></lsq-icon>
        </lsq-button>
    `,
    styleUrls: ['./lsq-export-button.component.scss']
})
export class LsqExportButtonComponent {
    @Input() public request: any;
    @Input() public service: ApiService<any, any>;
    @Input() public reportName: string;
    @Input() public isIcon = false;
    @Input() public isTransparent = false;
    @Input() public disabled = false;

    public exportTimeout: any;
    public isLoadingReport: any;
    private downloadSubscription: Subscription;

    public icons = Icons;

    public generationWaitMessage = this._i18n({
        value:
            'This can take several minutes. You can continue using the application, but refrain from closing/refreshing the page.',
        meaning: 'Notification for when report is taking long to generate'
    });
    public generationWaitMessageTitle = this._i18n({
        value: 'Report Generating',
        meaning: 'Title for notification for when report is taking long to generate'
    });

    constructor(
        private _downloadService: DownloadService,
        private _i18n: I18n,
        private _toastrService: ToastrService,
        @Inject(SETTINGS) private _settings: ISettings
    ) {}

    public handleClick(): void {
        this.isLoadingReport = true;
        const request = cloneDeep(this.request);
        let generatingMessageId: number = null;

        // If generating the report takes more than 10 sec, close and show the info toast.
        this.exportTimeout = setTimeout(
            () => {
                generatingMessageId = this.showGeneratingMessage();
            },
            this._settings.downloadBackgroundTimeout
                ? this._settings.downloadBackgroundTimeout
                : 10 * 1000
        ); // Use default just in case the setting is not set;

        if (this.downloadSubscription) {
            this.downloadSubscription.unsubscribe();
        }
        const exportRequest = this.service.requestMapper(request);
        this.downloadSubscription = this._downloadService
            .executeForJava(
                this.service,
                exportRequest ? exportRequest : request,
                FileType.Csv,
                this.reportName
            )
            .pipe(take(1))
            .subscribe((blob: Blob) => {
                this.isLoadingReport = false;
                this._toastrService.clear(generatingMessageId);
                clearTimeout(this.exportTimeout);
            });
    }

    private showGeneratingMessage(): number {
        const activeToast = this._toastrService.info(
            this.generationWaitMessage,
            this.generationWaitMessageTitle,
            {
                disableTimeOut: true
            }
        );
        return activeToast.toastId;
    }
}
